import { localizeConfig, type TranslateFn } from './localize'

export type ConfigItem = Record<string, any>

const rulesConfig: ConfigItem[] = [
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", text: "Rules" },
	{ type: "title", titleCss: "title", align: "center", text: "Candyland Bonanza Game Rules" },
	{ type: "pTag", pTagCss: "pTagStyle", align: "center", text: "By playing our games, you agree that you do not find them offensive, unfair or indecent." },
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "How to Play Slots:" },
	{
		type: "orderedList",
		align: "left",
		listCss: "orderedListStyle",
		additionalCss: "cssclass",
		text: [
			"Choose the amount you would like to bet with. Control the bet amount by clicking the arrows next to the Coin Value or choose Max Bet (Max Coin Value).",
			"Your winnings are automatically added to your account balance. You can see your Total Win displayed in the <b>WIN</b> section of the screen after each spin.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Game Rules:" },
	{
		type: "orderedList",
		align: "left",
		listCss: "orderedListStyle",
		additionalCss: "cssclass",
		text: [
			"The game is 5 reels and 7 rows slot game.",
			"Any horizontal or vertical line of 3 or more adjacent symbols of the same symbols is a win match.",
			"Only the longest matching combination for a given symbol in a matching line is paid.",
			"Winning combinations and payouts are made according to the paytable.",
			"Malfunction voids all pays and plays.",
			"For this game, the long-term expected payback is 94.68%.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Game Features:" },
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Avalanche Feature:" },
	{
		type: "orderedList",
		align: "left",
		listCss: "orderedListStyle",
		additionalCss: "cssclass",
		text: [
			"To win, player must match 8 or more symbols anywhere on the screen.",
			"Winning symbols will then disappear, and new symbols will cascade in their place, creating a new winning combination in a single spin.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Free Spins Feature:" },
	{
		type: "orderedList",
		align: "left",
		listCss: "orderedListStyle",
		additionalCss: "cssclass",
		text: [
			"4 or more Bonus symbols appearing on the base game awards 10 free spins.",
			"Free spins can be retriggered. If 3 or more Bonus symbols are triggered, 5 more free spins are awarded additionally.",
			"Up to 40 additional free spins can be awarded.",
			"During the free game, there is a Multiplier symbol (Candy Jar) which may appear on the reels and stays until free spin micro round is completed. Multiplier on Candy Jar symbol is multiplied with the total win of each spin.  If there are more than one Candy Jar symbol then all Multipliers on them are added together and is multiplied with the total win of each spin.",
			"When Candy Jar symbol lands on the screen, it awards a random multiplier with possible values of 2x, 3x, 4x, 5x, 6x,8x, 10x, 15x, 20x,25x, 50x, 100x.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Buy Bonus:" },
	{
		type: "orderedList",
		align: "left",
		listCss: "orderedListStyle",
		additionalCss: "cssclass",
		text: [
			"During the main game, player will have an option to BUY BONUS.",
			"Buy Bonus Price is 80 x Total Bets.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Game Controls:" },
	{
		type: "pTag",
		pTagCss: "pTagStyle",
		additionalCss: "azPTagStyle",
		align: "center",
		text: "This section lists the different buttons found in the game and describes their functions.",
	},
	{
		type: "table",
		align: "center",
		additionalCss: "testCSS",
		items: [
			[{ type: "text", align: "center", additionalCss: "testCss", text: "Buttons" }, { type: "text", align: "center", additionalCss: "testCss", text: "Function" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "menuBtn.png", imgPath: "/assets/infopages/rules/menuBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open menu" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "infoBtn.png", imgPath: "/assets/infopages/rules/infoBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open the PAYTABLE" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "settingsBtn.png", imgPath: "/assets/infopages/rules/settingsBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open the GAME SETTINGS" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "rulesBtn.png", imgPath: "/assets/infopages/rules/rulesBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open the GAME RULES" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "fullscreenBtn.png", imgPath: "/assets/infopages/rules/fullscreenBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to switch full screen / exit full screen" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "volumeOn.png", imgPath: "/assets/infopages/rules/volumeOn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to switch Sound on / off" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "spinBtn.png", imgPath: "/assets/infopages/rules/spinBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to Spin" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "autospin.png", imgPath: "/assets/infopages/rules/autospin.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap to open Auto Spin" }],
			[{ type: "image", align: "center", additionalCss: "testCss", imgName: "closeBtn.png", imgPath: "/assets/infopages/rules/closeBtn.png" }, { type: "text", align: "left", additionalCss: "testCss", text: "Click / Tap the X button to return to the game" }],
		],
	},
	{
		type: "pTag",
		pTagCss: "pTagStyle",
		additionalCss: "azPTagStyle",
		align: "center",
		text: "You can place restrictions on game play by following any of these options:",
	},
	{
		type: "orderedList",
		align: "left",
		listCss: "orderedListStyle",
		additionalCss: "cssclass",
		text: [
			"Stop on any win: <b>Auto-bet</b> function is stopped when you get any winning combination.",
			"Stop on single win limit: Based on the limit value selected, the <b>Auto-bet</b> function is stopped when your total win in a single game reaches the selected value.",
			"Stop on Session Loss Limit: Based on the limit value selected, the <b>Auto-bet</b> function is stopped when your total loss in the session reaches the selected value, which is derived by bets minus wins.",
		],
	},
	{
		type: "image",
		imgCSS: "settingsPanel",
		align: "center",
		additionalCss: "additionalCss",
		imgName: "autoSpinSettings.png",
		imgPath: "/assets/infopages/rules/autoSpinSettings.png",
	},
	{
		type: "orderedList",
		align: "left",
		listCss: "orderedListStyle",
		additionalCss: "cssclass",
		text: [
			"All games are tested to level 3 standards in accordance with the UKGC Testing Strategy for Compliance with the Remote Gambling and Software Technical Standards.",
			"If the game is interrupted due to connection loss during Free Spins or Bonus Rounds, the game will resume the remaining Free Spins or the pending Bonus Round upon re-opening.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Auto Spin Game Rules:" },
	{
		type: "orderedList",
		align: "left",
		listCss: "orderedListStyle",
		additionalCss: "cssclass",
		text: [
			"<b>Auto Spin</b> is similar to a regular spin, you can choose <b>Auto Spin</b> for a selected number of spins.",
			"As soon as <b>Auto Spin</b> begins, the <b>Auto Spin</b> button is replaced by a counter displaying the remaining <b>Auto-bet</b> rounds. The <b>Auto Spin</b> button changes to the <b>Stop Auto Spin</b> icon.",
			"<b>Auto Spin</b> automatically plays the game for the selected number of rounds.",
			"<b>Auto Spin</b> can be stopped at any time by clicking / tapping the <b>Auto Spin</b> (Auto Stop) button.",
			"<b>Auto Spin</b> settings will return to default when you trigger any Feature round (Free spins / Bonus Round).",
			"If you are disconnected while playing, all <b>Auto-play</b> settings will return to default when you reload the game.",
		],
	},
	{ type: "subtitle", subTitleCss: "subTitle", align: "left", additionalCss: "azSubtitle", text: "Additional Information:" },
	{
		type: "orderedList",
		align: "left",
		listCss: "orderedListStyle",
		additionalCss: "cssclass",
		text: [
			"Guidance on RTP / Paylines / Bonus Feature / Wild / Free Spins is covered under the Paytable section of respective games. You can access this by clicking / tapping the <b>Paytable</b> button.",
			"Any stakes that you place are non-refundable, unless a system malfunction occurs, in which case, all stakes placed on the particular game being played at the time of the malfunction will be refunded. We have no obligation to repay players who abuse these occurrences, and  therefore, an alternative may be deemed suitable depending on the individual circumstances.",
			"The in-game paytable shows symbol payouts as the multipliers on the total bet amount, which is calculated as 'total bet = (coin value * number of fixed coins)'. Hence the actual payouts  will be coin value * paytable factor when bet lines are kept constant.",
			"If a query arises as a result of a gaming session, where there is a mismatch between your  records and the data recorded by our servers, the latter will be considered correct.",
			"In the event of any disagreement between yourself and this website, the management's decision will be considered final.",
			"If the game is interrupted due to connection loss, <b>Balance</b> and <b>Win</b> information  can be viewed using Game Logs.",
			"In the event of malfunction of gaming hardware / software, all affected game bets and payouts are rendered void and all affected bets refunded.",
		],
	},
]

export const getRulesConfig = (translate: TranslateFn): ConfigItem[] => localizeConfig(rulesConfig, translate)
